import { httpClient } from '~/lib/http-client'
import type {
  CreateUnionRequest,
  Union,
  UpdateUnionRequest,
} from '~/types/union'

/**
 * Lista todos os sindicatos
 */
export async function listUnions(federationId?: number) {
  return httpClient.get<Union[]>('/sindicatos', {
    useAuth: true,
    params: federationId ? { federacao_id: federationId } : undefined,
  })
}

/**
 * Obtém um sindicato específico
 */
export async function getUnion(id: number) {
  return httpClient.get<Union>(`/sindicatos/${id}`, { useAuth: true })
}

/**
 * Cria um novo sindicato
 */
export async function createUnion(data: CreateUnionRequest) {
  return httpClient.post<{ message: string; sindicato: Union }>(
    '/sindicatos',
    { ...data },
    { useAuth: true }
  )
}

/**
 * Atualiza um sindicato
 */
export async function updateUnion(id: number, data: UpdateUnionRequest) {
  return httpClient.put<{ message: string; sindicato: Union }>(
    `/sindicatos/${id}`,
    { ...data },
    { useAuth: true }
  )
}

/**
 * Exclui um sindicato
 */
export async function deleteUnion(id: number) {
  return httpClient.delete<{ message: string }>(`/sindicatos/${id}`, {
    useAuth: true,
  })
}
